import { useEventBus } from '@vueuse/core'

export interface ShortcutWidgetTypeChange {
  id: string
  type: string
}

export interface InfoboardWidgetSettingsChange {
  items: number
  visibleTypes: string[]
  visibleState: boolean
}

export function useShortcutWidgetBus() {
  return useEventBus<ShortcutWidgetTypeChange>('widget-shortcut-type-change')
}

export function useInfoboardWidgetBus() {
  return useEventBus<InfoboardWidgetSettingsChange>('widget-infoboard-settings-change')
}